import React, { useMemo, useState } from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Checkbox } from '@/components/ui/checkbox';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { C, EmptyState, FilterSelect, StatusBadge, TableShell } from '@/design-system/dna';
import { AUTH, PAY_STATUS } from './shared';

const ALL = 'all';

/** Filtros + busca + seleção, compartilhado pelas abas. */
export function useParticipantFilter(parts) {
  const [q, setQ] = useState('');
  const [cls, setCls] = useState(ALL);
  const [st, setSt] = useState(ALL);
  const classes = useMemo(() => [...new Map(parts.map((p) => [p.class_id, p.class_name])).entries()], [parts]);
  const needle = q.trim().toLowerCase();
  const list = parts.filter((p) => (cls === ALL || p.class_id === cls) && (st === ALL || p.status === st)
    && (!needle || p.student_name.toLowerCase().includes(needle) || (p.responsible_name || '').toLowerCase().includes(needle)));
  const toolbar = (
    <>
      <div className="relative"><Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2" style={{ color: C.muted }} /><Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Aluno ou responsável" className="h-10 w-[220px] rounded-full pl-9" data-testid="evento-busca" /></div>
      <FilterSelect id="evento-filtro-turma" value={cls} onChange={setCls} items={[{ value: ALL, label: 'Todas as turmas' }, ...classes.map(([v, l]) => ({ value: v, label: l }))]} />
      <FilterSelect id="evento-filtro-status" value={st} onChange={setSt} items={[{ value: ALL, label: 'Todas as situações' }, ...Object.entries(PAY_STATUS).map(([v, m]) => ({ value: v, label: m.label }))]} />
    </>
  );
  return { list, toolbar };
}

export function SelectAll({ list, sel, setSel }) {
  const ids = list.map((p) => p.student_id);
  const all = ids.length > 0 && ids.every((i) => sel.includes(i));
  return <Checkbox checked={all} onCheckedChange={() => setSel(all ? sel.filter((i) => !ids.includes(i)) : [...new Set([...sel, ...ids])])} data-testid="evento-sel-todos" />;
}

export const PayBadge = ({ p }) => <span className="inline-flex flex-col items-start gap-0.5"><StatusBadge tone={PAY_STATUS[p.status].tone} testid={`evento-pay-status-${p.student_id}`}>{PAY_STATUS[p.status].label}</StatusBadge>{p.vencido && <span className="text-[10px] font-semibold" style={{ color: C.magenta }}>evento já passou</span>}</span>;
export const AuthBadge = ({ p }) => <StatusBadge tone={AUTH[p.autorizacao || 'pendente'].tone} testid={`evento-auth-${p.student_id}`}>{AUTH[p.autorizacao || 'pendente'].label}</StatusBadge>;

export function ParticipantShell({ title, toolbar, head, rows, footer, testid, empty }) {
  return (
    <TableShell title={title} toolbar={toolbar} footer={footer} testid={testid}>
      {rows.length ? (
        <Table><TableHeader><TableRow>{head.map((h, i) => <TableHead key={i}>{h}</TableHead>)}</TableRow></TableHeader><TableBody>{rows}</TableBody></Table>
      ) : <div className="p-5"><EmptyState title={empty || 'Nenhum aluno'} testid={`${testid}-empty`}>Selecione as turmas participantes na aba Turmas e Alunos ou ajuste os filtros.</EmptyState></div>}
    </TableShell>
  );
}

export { TableRow, TableCell };
